<template>
    <div>
        <div class="row">
            <div class="col-md-9">
                <ul class="list-group user-account-group">
                    <li class="list-group-item">
                        <a @click.stop="showAccountMaintenance" href="#">
                            #{{ account_nbr }} {{ account_nm }}
                        </a>
                        ({{ account_city }},{{ account_state }})
                        <span v-if="is_credit_and_collection" class="text-warning text-uppercase m-l-5">
                            (C&amp;C Hold)
                        </span>

                        <span class="label" :class="environmentDisplayClass">
                            {{ industryDecode }}
                        </span>

                        <a role="button" class="btn text m-l-10 add-pointer" @click.stop="" target="_blank"
                            :href="'http://intranet.midwestlabs.com/cgi-bin/accounts/accountEditFront.pl?account=' + account_nbr">
                            <span class="fa fa-external-link"></span>View in LIMS
                        </a>

                        <span v-show="has_pending_approval" class="label label-warning">
                            Waiting Approval
                        </span>
                    </li>

                    <account-role-item v-for="(role, index) in filtered_roles" :key="role.role_cd" :type="'approval'"
                        :role_cd="role.role_cd" :role_desc="role.role_desc" :user_account_roles="local_roles_array"
                        :source="'account'" :is_unavailable="isRoleUnavailable(role.role_cd)"
                        @add="addRolesArray(index)" @delete="deleteRolesArray(index)"></account-role-item>
                </ul>
            </div>

            <div class="col-md-1 m-t-15">
                <span v-if="form_errors.length" class="simple-error">
                    {{ form_errors }}
                </span>
                <span v-if="form_status" class="simple-status">
                    {{ form_status }}
                </span>
            </div>

            <div class="col-md-2 m-t-15">
                <div class="pull-right">
                    <button @click="savePermissions" class="btn btn-primary btn-bold m-l-10"
                        :disabled="!rolesChanged || saveDisabled">
                        <i class="fa fa-check"></i>Save <br> Permissions
                    </button>
                </div>
            </div>
        </div>
        <hr>
    </div>
</template>

<script>
module.exports = {
    props: [
        'user_id',
        'account_nbr',
        'account_nm',
        'account_city',
        'account_state',
        'account_industry_id',
        'has_pending_approval',
        'user_account_roles',
        'industry_list',
        'all_roles',
        'index',
        'is_credit_and_collection',
        'sole_admin_self',
    ],

    data: function () {
        return {
            form_errors: {},
            form_status: '',
            local_roles_array: [],
            saving: false,
            lastSavedRolesSnapshot: {},
        };
    },

    computed: {
        roles_array() {
            return this.user_account_roles || {};
        },

        filtered_roles() {
            return this.all_roles;
        },

        rolesChanged() {
            const local = this.local_roles_array || {};
            const saved = this.lastSavedRolesSnapshot || {};

            const localKeys = Object.keys(local);
            const savedKeys = Object.keys(saved);

            if (localKeys.length !== savedKeys.length) {
                return true;
            }

            return localKeys.some(role => !saved.hasOwnProperty(role) || saved[role] !== local[role]);
        },


        saveDisabled() {
            return this.saving;
        },

        targetHasAuthAdFromBackend() {
            return (
                this.roles_array &&
                this.roles_array.hasOwnProperty('AUTH_AD') &&
                (this.roles_array['AUTH_AD'] === 0 ||
                    this.roles_array['AUTH_AD'] === 1)
            );
        },

        targetHasAuthAdEffective() {
            const value = this.local_roles_array['AUTH_AD'];
            return value === 0;
        },

        industryDecode() {
            let pos = this.industry_list
                .map(function (a) {
                    return a.industry_id;
                })
                .indexOf(this.account_industry_id);

            if (pos !== -1) {
                return this.industry_list[pos].industry_nm.replace('&amp;', '&');
            }

            return '';
        },

        environmentDisplayClass() {
            return `industry-${this.industryDecode.substring(0, 3).toLowerCase()}`;
        },
    },

    watch: {
        user_account_roles() {
            this.copyRolesArray();
        },
    },

    methods: {
        showAccountMaintenance() {
            window.location.href = `/admin/accountroles/${this.account_nbr}`;
        },

        resetMessages() {
            this.form_errors = {};
            this.form_status = '';
        },

        copyRolesArray() {
            this.local_roles_array = _.clone(this.roles_array);

            if (!this.targetHasAuthAdFromBackend) {
                this.ensureAuthorizedConstraints();
            }
            this.lastSavedRolesSnapshot = _.clone(this.local_roles_array);
        },

        ensureAuthorizedConstraints() {
            const AUTH = 'AUTH_AD';
            const GROUPS = ['SUP', 'ANLYSIS', 'RPRT'];
            if (!this.local_roles_array.hasOwnProperty(AUTH)) return;

            if (this.local_roles_array.hasOwnProperty('BILL')) {
                Vue.delete(this.local_roles_array, 'BILL');
            }

            const hasAnyGroup = GROUPS.some(cd =>
                this.local_roles_array.hasOwnProperty(cd)
            );

            if (!hasAnyGroup) {
                GROUPS.forEach(cd => {
                    if (!this.local_roles_array.hasOwnProperty(cd)) {
                        Vue.set(this.local_roles_array, cd, 0);
                    }
                });
            }
        },

        checkAllExceptAuthAdAndSelf() {
            const EXCLUDE = new Set(['AUTH_AD', 'ACT_ADM']);

            this.all_roles.forEach(r => {
                const cd = r.role_cd;

                if (EXCLUDE.has(cd)) return;
                if (this.isRoleUnavailable(cd)) return;
                if (this.local_roles_array.hasOwnProperty(cd)) return;

                Vue.set(this.local_roles_array, cd, 0);
            });
        },

        isRoleUnavailable(role_cd) {
            if (role_cd === 'BILL' && this.targetHasAuthAdEffective) return true;

            if (role_cd === 'ACT_ADM' && this.sole_admin_self) return true;

            return false;
        },

        addRolesArray(role_index) {
            this.resetMessages();
            const user_role_cd = this.filtered_roles[role_index].role_cd;

            if (user_role_cd === 'BILL' && this.targetHasAuthAdEffective) return;

            Vue.set(this.local_roles_array, user_role_cd, 0);

            if (user_role_cd === 'AUTH_AD') {
                this.ensureAuthorizedConstraints();
            }
            if (user_role_cd === 'ACT_ADM') {
                this.checkAllExceptAuthAdAndSelf();
            }
        },

        revertOrDeleteRole(user_role_cd) {
            if (
                this.roles_array.hasOwnProperty(user_role_cd) &&
                this.roles_array[user_role_cd] === 1
            ) {
                Vue.set(this.local_roles_array, user_role_cd, 1);
            } else {
                Vue.delete(this.local_roles_array, user_role_cd);
            }
        },

        deleteRolesArray(role_index) {
            this.resetMessages();
            const user_role_cd = this.filtered_roles[role_index].role_cd;
            this.revertOrDeleteRole(user_role_cd);
        },

        removeUnapprovedRoles() {
            for (let role_cd in this.local_roles_array) {
                if (
                    this.local_roles_array.hasOwnProperty(role_cd) &&
                    this.local_roles_array[role_cd] === 1
                ) {
                    Vue.delete(this.local_roles_array, role_cd);
                }
            }
        },

        savePermissions() {
            this.resetMessages();
            this.form_status = 'Saving...';
            this.saving = true;

            this.removeUnapprovedRoles();
            const role_keys = Object.keys(this.local_roles_array);

            this.$http.post('/admin/users/approve-account-roles', {
                user_id: this.user_id,
                account_nbr: this.account_nbr,
                role_keys: role_keys,
            })
                .then(function (response) {
                    this.form_status = response.data.status;

                    this.lastSavedRolesSnapshot = _.clone(this.local_roles_array);
                })
                .catch(function (data, status, request) {
                    this.form_status = '';
                    this.form_errors = data.body.errors[0];
                })
                .finally(() => {
                    this.saving = false;
                    this.$emit('resetPending', this.index);
                });
        },
    },

    mounted() {
        this.copyRolesArray();
    },
};
</script>



// WEBPACK FOOTER //
// sys-admin-account-role-list.vue?0575509a